module.exports = __webpack_public_path__ + "static/media/kay_rauber.4f72c795.jpg";